module.exports = __webpack_public_path__ + "img/cr.ee79f883.svg";